import request from '@/utils/request'

/**
 * 获取公告详情
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getNoticeDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/notice.listNotices',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}


/**
 * 获取账户明细详情
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getAccountDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountDetail.listAccountDetails',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}






/**
 * 获取季度财务详情
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getQuarterDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/finance.listQuarterlyFinances',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
